import type { WebGLRenderer } from "three";
import { PMREMGenerator } from "three";

const pmremGeneratorCache = new WeakMap<WebGLRenderer, PMREMGenerator>();

export function getPmremGenerator(renderer: WebGLRenderer): PMREMGenerator {
  const pmremGenerator = pmremGeneratorCache.get(renderer);
  if (pmremGenerator) {
    return pmremGenerator;
  }
  const newPmremGenerator = new PMREMGenerator(renderer);
  pmremGeneratorCache.set(renderer, newPmremGenerator);
  return newPmremGenerator;
}
